export const RECEIVING_POINT = 0;
export const AGENCY_RECEPTION_POINT = 1;
export const FACTORY = 2;
export const AGENCY_FACTORY = 3;
export const MOBILE_POINT = 4;

export const dcDepartmentTypes = [
    { Id: RECEIVING_POINT, Name: "Точка приема" },
    { Id: AGENCY_RECEPTION_POINT, Name: "Агентская точка приема" },
    { Id: FACTORY, Name: "Фабрика" },
    { Id: AGENCY_FACTORY, Name: "Агентская фабрика" },
    { Id: MOBILE_POINT, Name: "Мобильная точка" },
];

export const factories = [
    dcDepartmentTypes[FACTORY],
    dcDepartmentTypes[AGENCY_FACTORY]
];

export const acceptPoints = [
    dcDepartmentTypes[RECEIVING_POINT],
    dcDepartmentTypes[AGENCY_RECEPTION_POINT]
];
export function getDepartmentTypeById(id) {
    const type = dcDepartmentTypes.find(d => d.Id == id);
    return type ? type.Name : "";
}


// WEBPACK FOOTER //
// ./src/constants/dcDepartmentTypes.js